<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛">
		<FHeader :checkId="26"></FHeader>
		<FOtherBanner :name1="'专业人员'" :name2="'Professional'"></FOtherBanner>
		<article style="height: 100%;">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black">专业人员</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;">
				<div style="text-align: center;">
					<div style="font-size: 26px;font-weight: 900;color: #98273A;">专业人员</div>
					<div style="padding-top: 5px;font-size: 14px;color: #98273A;">Professional</div>
				</div>
				<div style="text-align: center;margin-top: 50px;" class="professionalSelect">
					<div style="width: 20%;float: left;margin-left: 2.5%;">
						<el-input
							v-model="name"
							placeholder="按姓名搜索">
							<i
								class="el-icon-search el-input__icon"
								slot="suffix"
								@click="queryParam()">
							</i>
						</el-input>
					</div>
					<div style="width: 20%;float: left;margin-left: 5%;">
						<el-select v-model="relationship_id" clearable placeholder="按职位搜索" @change="queryParam()">
							<el-option
								v-for="item in relationshipList"
								:key="item.id"
								:label="item.label"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<div style="width: 20%;float: left;margin-left: 5%;">
						<el-select v-model="service_id" clearable placeholder="按业务领域搜索" @change="queryParam()">
							<el-option
								v-for="item in serviceList"
								:key="item.id"
								:label="item.title"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<div style="width: 20%;float: left;margin-left: 5%;margin-right: 2.5;">
						<el-select v-model="address_name" clearable placeholder="按地区搜索" @change="queryParam()">
							<el-option
								v-for="item in ['上海','唐山','西安','太原','郑州','海口','重庆','合肥']"
								:key="item"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
					</div>
				</div>
				<div :style="{'padding-top':'30px','height':((Math.ceil(tableList.length/2)*360)+50)+'px'}">
					<div :style="{height:'260px','margin-top':'70px',width:'47.5%','margin-left':index%2==0?'0':'5%',float:'left'}" v-for="(item,index) in tableList" :key="index">
						<div style="float:left;width:40%;">
							<img style="height:260px;width:100%;cursor: pointer;"  @click="toDetail(item)" :src="item.image">
						</div>
						<div style="float: left;width: 55%;padding-left: 5%;">
							<div @click="toDetail(item)" style="padding-top: 60px;font-size: 20px;cursor: pointer;">{{item.name}}</div>
							<div style="font-size: 12px;margin-top: 15px;color: #999999;padding-bottom: 15px;border-bottom: 1px solid #D7D7D7;">{{item.relationship_name}}</div>
							<div style="padding-top: 25px;font-size: 14px;color: #666666;line-height: 22px;">{{item.content}}</div>
						</div>
					</div>
				</div>
				<el-pagination
					background
					layout="prev, pager, next, jumper"
					:page-size="6"
					:total="total"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import {queryTreeChannelByPid} from '@/api/channel'
	import {queryService} from "@/api/service";
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {query} from "@/api/lawyer";
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			Footer
		},
		data() {
			return {
				tableList: [],
				total:0,
				pageNo: 1,
				name:'',
				address_name:'',
				relationship_id:null,
				relationshipList:[],
				service_id:null,
				serviceList: [],
			}
		},
		created() {
			this.relationship_id = this.$route.query.type && this.$route.query.type != 'null'?parseInt(this.$route.query.type):null
			this.pageNo = 1;
			this.query()
			this.queryRelationshipList()
			this.queryServiceList()
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		mounted() {
			this.relationship_id = this.$route.query.type && this.$route.query.type != 'null'?parseInt(this.$route.query.type):null
			this.pageNo = 1;
			this.query()
			this.queryRelationshipList()
			this.queryServiceList()
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
			
		},
		activated(){
			this.relationship_id = this.$route.query.type && this.$route.query.type != 'null'?parseInt(this.$route.query.type):null
			this.pageNo = 1;
			this.query()
			this.queryRelationshipList()
			this.queryServiceList()
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			toDetail(item,index){
				this.$router.push(
					{
						path:'/professionalDetail',
						query:{
							id:item.id
						}
					}
				);
			},
			queryRelationshipList(){
				queryTreeChannelByPid(26).then(data => {
					this.relationshipList = data.data
					console.log(this.treeData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			queryServiceList(){
				let param = {
					page: 1,
					pageSize: 99999,
				}
				queryService(param).then(data => {
					this.serviceList = data.data.list
					console.log(this.treeData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			handleCurrentChange(page){
				this.pageNo = page
				this.query()
			},
			changeRelationshipId(relationship_id){
				this.relationship_id = relationship_id;
				this.pageNo = 1;
				this.query()
			},
			handleIconClick(){
				console.log('handleIconClick')
			},
			queryParam(){
				this.pageNo = 1;
				this.query()
			},
			query() {
				let param = {
					name: this.name,
					service_id: this.service_id,
					relationship_id: this.relationship_id,
					address_name:this.address_name,
					page: this.pageNo,
					pageSize: 6,
				}
				query(param).then(data => {
					this.tableList = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">


	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
.professionalSelect /deep/ .el-select {
    width: 100%;
}
.professionalSelect /deep/ input::placeholder {
    color: #A9A9A9;
}
.professionalSelect /deep/ .el-input__icon {
    color: #A9A9A9;
}
.professionalSelect /deep/ .el-input__inner{
	height: 55px;
    border-radius: 35px;
    padding: 0 25px;
		border-color: #A9A9A9;
}
.professionalSelect /deep/ .el-input__suffix{
    padding-right: 15px;
}
.cultureType{
	cursor: pointer;
}
div /deep/ .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div /deep/ .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div /deep/ .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div /deep/ .el-pagination{
	text-align: center;
}
</style>
